import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const  originalPush=VueRouter.prototype.push
VueRouter.prototype.push=function push(location){
  return originalPush.call(this,location).catch(err=>err)
}
const routes = [
  {
    path: '/',
    name: 'home',
    meta: { keepAlive: true },
    component: HomeView
  },
  {
    path: '/news/details',
    name: 'news/details',
    component: () => import(/* webpackChunkName: "about" */ '../views/newDetails')
  },
  {
    path: '/serviceField',
    name: 'serviceField',
    meta: { keepAlive: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/about/serviceField')
  },
  {
    path: '/PartyBuilding',
    name: 'PartyBuilding',
    component: () => import(/* webpackChunkName: "about" */ '../views/partyBuilding/index'),
    meta: { keepAlive: true },
  },
  {
    path: '/partyBuilding/details',
    name: 'partyBuilding/details',
    component: () => import(/* webpackChunkName: "about" */ '../views/partyBuilding/details')
  },
  {
    path: '/culture',
    name: 'culture',
    meta: { keepAlive: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/culture/Culture')
  },
  {
    path: '/culture/details',
    name: 'culture/details',
    component: () => import(/* webpackChunkName: "about" */ '../views/culture/details')
  },
  {
    path: '/members',
    name: 'members',
    meta: { keepAlive: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/members/index')
  },
  {
    path: '/recruit',
    name: 'recruit',
    meta: { keepAlive: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/recruit/index')
  },
  {
    path: '/recruit/details',
    name: 'recruit/details',
    component: () => import(/* webpackChunkName: "about" */ '../views/recruit/details')
  },
  {
    path: '/about',
    name: 'about',
    meta: { keepAlive: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/about/about')
  },
  {
    path: '/tendering',
    name: 'tendering',
    meta: { keepAlive: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/tendering/index')
  },
  {
    path: '/tendering/details',
    name: 'tendering/details',
    component: () => import(/* webpackChunkName: "about" */ '../views/tendering/details')
  },
  {
    path: '/admin/login',
    name: 'login',
    component: () => import('../views/admin/login')
  },
  {
    path: '/admin/unit',
    name: '/admin/unit',
    component: () => import('../views/admin/unit/index')
  },
  {
    path: '/admin/leader',
    name: '/admin/leader',
    component: () => import('../views/admin/leader/index')
  },
  {
    path: '/admin/article',
    name: '/admin/article',
    component: () => import('../views/admin/article/index')
  },
  {
    path: '/admin/honor',
    name: '/admin/honor',
    component: () => import('../views/admin/banner/honor')
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,

  scrollBehavior(to) {
    if (to.meta.savedPosition) {
    // 尝试恢复滚动位置，如果savedPosition存在的话
      return to.meta.savedPosition;
    } else {
      // 否则，返回顶部
      return { x: 0, y: 0 };
    }
  },
})
export default router
